import Downloads from './Downloads';

const View = (props) => {
  return <Downloads showDisclaimer={false} showShareButton={true} />;
};

export default View;
